import posthog from 'posthog-js'

export default {
    install(Vue) {
        let phDev = 'phc_cBIDnSTfc5CdHLXerahqHxsauE0wAjyRYgy6p8BevPK';
        let phProd = 'phc_kRkkbM1m3deFdsjoB4tdD8zoI5piDUHHn5C30eIp3qd';

        posthog.init(Vue.prototype.$Params.Environment=='0' ? phDev : phProd, {
            api_host: 'https://eu.i.posthog.com',
        })

        posthog.register({
            portal_type: 'employee_doc_portal_suasor'
        })

        Vue.prototype.$posthog = posthog
    }
}
